// DO NOT EDIT -- generated from fs/services/search-settings/metrics.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as metrics from '../../api/metrics';
import * as pagination from '../../shared/pagination';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as visualizationsettings from './visualizationsettings';

export namespace Metrics {

  export const GetAllMetricsEndpoint = "/grpc/search_settings.Metrics/GetAllMetrics";
  /**
   * Get all current non-archived metrics for an org.
   * If desired, archived metrics can also be retrieved with the explicit request flag.
   */
  export function GetAllMetrics(sender: (req: GetAllMetricsRequest, endpoint: string) => Promise<GetAllMetricsResponse>, req: GetAllMetricsRequest): { promise: () => Promise<GetAllMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllMetricsEndpoint),
      endpoint: GetAllMetricsEndpoint
    };
  }

  export const GetMetricEndpoint = "/grpc/search_settings.Metrics/GetMetric";
  /** Get a specific metric, either current or past version. */
  export function GetMetric(sender: (req: GetMetricRequest, endpoint: string) => Promise<GetMetricResponse>, req: GetMetricRequest): { promise: () => Promise<GetMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMetricEndpoint),
      endpoint: GetMetricEndpoint
    };
  }

  export const BatchGetMetricsEndpoint = "/grpc/search_settings.Metrics/BatchGetMetrics";
  export function BatchGetMetrics(sender: (req: BatchGetMetricsRequest, endpoint: string) => Promise<BatchGetMetricsResponse>, req: BatchGetMetricsRequest): { promise: () => Promise<BatchGetMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetMetricsEndpoint),
      endpoint: BatchGetMetricsEndpoint
    };
  }

  export const SetMetricEndpoint = "/grpc/search_settings.Metrics/SetMetric";
  /** Add a new metric or update an existing metric. */
  export function SetMetric(sender: (req: SetMetricRequest, endpoint: string) => Promise<SetMetricResponse>, req: SetMetricRequest): { promise: () => Promise<SetMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetMetricEndpoint),
      endpoint: SetMetricEndpoint
    };
  }

  export const ArchiveMetricEndpoint = "/grpc/search_settings.Metrics/ArchiveMetric";
  /**
   * Archive an existing metric for an org.
   * Once archived, the metric cannot be modified and will not show up in GetAllMetrics unless explicitly requested.
   */
  export function ArchiveMetric(sender: (req: ArchiveMetricRequest, endpoint: string) => Promise<ArchiveMetricResponse>, req: ArchiveMetricRequest): { promise: () => Promise<ArchiveMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMetricEndpoint),
      endpoint: ArchiveMetricEndpoint
    };
  }

  export const UnarchiveMetricEndpoint = "/grpc/search_settings.Metrics/UnarchiveMetric";
  /**
   * Unarchives an existing metric for an org.
   * Once unarchived, the metric can continue to be modified and will show up in GetAllMetrics.
   */
  export function UnarchiveMetric(sender: (req: UnarchiveMetricRequest, endpoint: string) => Promise<UnarchiveMetricResponse>, req: UnarchiveMetricRequest): { promise: () => Promise<UnarchiveMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveMetricEndpoint),
      endpoint: UnarchiveMetricEndpoint
    };
  }

  export const GetMetricsAccessEndpoint = "/grpc/search_settings.Metrics/GetMetricsAccess";
  export function GetMetricsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMetricsAccessEndpoint),
      endpoint: GetMetricsAccessEndpoint
    };
  }

  export const InvalidateCachedMetricEndpoint = "/grpc/search_settings.Metrics/InvalidateCachedMetric";
  export function InvalidateCachedMetric(sender: (req: InvalidateCachedMetricRequest, endpoint: string) => Promise<{}>, req: InvalidateCachedMetricRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, InvalidateCachedMetricEndpoint),
      endpoint: InvalidateCachedMetricEndpoint
    };
  }
}

export namespace MetricsPublic {

  export const GetMetricsAccessEndpoint = "/grpc/search_settings.MetricsPublic/GetMetricsAccess";
  export function GetMetricsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMetricsAccessEndpoint),
      endpoint: GetMetricsAccessEndpoint
    };
  }
}

export interface GetAllMetricsRequest {
  orgId: string;
  /** If true, archived metrics will also be returned. */
  includeArchived: boolean;
  pageInfo: pagination.PageInfoRequest | null;
  includeCanned: boolean;
  /** By default, only public metrics are returned */
  includePrivate: boolean;
}

export interface GetAllMetricsResponse {
  metrics: MetricRecord[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface GetMetricRequest {
  /** required */
  orgId: string;
  /** required */
  metricId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetMetricResponse {
  versions: MetricRecord[];
}

export interface BatchGetMetricsRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetMetricsRequest.Identifier[];
  /** optional, max number of records to return for unspecified versions; defaults to a single record */
  limit: number;
}

export namespace BatchGetMetricsRequest {
  export interface Identifier {
    /** required */
    metricId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned */
    version: protobuf.int64;
  }
}

export interface BatchGetMetricsResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found metrics will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetMetricsResponse.Result[];
}

export namespace BatchGetMetricsResponse {
  export interface Result {
    identifier: BatchGetMetricsRequest.Identifier | null;
    versions: MetricRecord[];
  }
}

export interface SetMetricRequest {
  orgId: string;
  /**
   * Metric to be created or updated.
   * If the id field is not set, an id will be generated and a new metric will be stored.
   * TODO(clay - once client cuts over): If the id field is set, an existing metric must already be persisted.
   */
  metric: Metric | null;
  isDcmCreated: boolean;
  visibility: protoauditstore.Visibility;
}

export interface SetMetricResponse {
  metric: MetricRecord | null;
}

export interface ArchiveMetricRequest {
  orgId: string;
  metricId: string;
}

export interface ArchiveMetricResponse {
  metric: MetricRecord | null;
}

export interface UnarchiveMetricRequest {
  orgId: string;
  metricId: string;
}

export interface UnarchiveMetricResponse {
  metric: MetricRecord | null;
}

export interface InvalidateCachedMetricRequest {
  orgId: string;
  metricId: string;
}

export interface Metric {
  id: string;
  name: string;
  description: string;
  metric: metrics.Metric | null;
  trend?: visualizationsettings.TrendSettings | null;
  singleNumber?: visualizationsettings.SingleNumberSettings | null;
  dimensionality?: visualizationsettings.DimensionalitySettings | null;
  /** An optional field for filtering a metric by users who complete funnel steps */
  funnelFilter: FunnelFilter | null;
}

export namespace Metric {
  export enum settings {
    trend = 5,
    singleNumber = 6,
    dimensionality = 7
  }

  export function settings_oneof(m: Metric): { opt: settings.dimensionality, val: visualizationsettings.DimensionalitySettings } | { opt: settings.singleNumber, val: visualizationsettings.SingleNumberSettings } | { opt: settings.trend, val: visualizationsettings.TrendSettings } | null {
    if (m.trend != null) { return { opt: settings.trend, val: m.trend } }
    if (m.singleNumber != null) { return { opt: settings.singleNumber, val: m.singleNumber } }
    if (m.dimensionality != null) { return { opt: settings.dimensionality, val: m.dimensionality } }
    return null;
  }
}

export interface FunnelFilter {
  /** Filter by the completion of an event sequence (use for custom or derived funnels) */
  funnelEvents?: segment.EventSequence | null;
  /** Filter by the completion of a saved funnel */
  funnelCompletion?: FunnelCompletion | null;
}

export namespace FunnelFilter {
  export enum funnel {
    /** Filter by the completion of an event sequence (use for custom or derived funnels) */
    funnelEvents = 1,
    /** Filter by the completion of a saved funnel */
    funnelCompletion = 2
  }

  export function funnel_oneof(m: FunnelFilter): { opt: funnel.funnelCompletion, val: FunnelCompletion } | { opt: funnel.funnelEvents, val: segment.EventSequence } | null {
    if (m.funnelEvents != null) { return { opt: funnel.funnelEvents, val: m.funnelEvents } }
    if (m.funnelCompletion != null) { return { opt: funnel.funnelCompletion, val: m.funnelCompletion } }
    return null;
  }
}

export interface FunnelCompletion {
  funnelId: string;
  /** What step of the funnel to use as the completion step (inclusive) */
  completionStep: number;
}

export interface MetricRecord {
  metric: Metric | null;
  metadata: protoauditstore.AuditMetadata | null;
  /**
   * Whether this metric was created as part of the dashboard card migration.
   * Temporary field to be removed after DCM is rolled out.
   * See https://docs.google.com/document/d/1HYT7HIQpbP4SbSgzy6oIYAzCCzRUxoeuotNPr8ZYveg/edit#
   */
  isDcmCreated: boolean;
  /** Whether this is a canned metric */
  isCanned: boolean;
}
